import './scss/index.scss';
import { dcFactory } from 'dc';
import AccountEventsComponent from './js/account-events.component';

dcFactory.register(AccountEventsComponent);
